import { render, staticRenderFns } from "./SelectMarketMode.vue?vue&type=template&id=ed87c052&scoped=true"
import script from "./SelectMarketMode.vue?vue&type=script&lang=js"
export * from "./SelectMarketMode.vue?vue&type=script&lang=js"
import style0 from "./SelectMarketMode.vue?vue&type=style&index=0&id=ed87c052&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed87c052",
  null
  
)

export default component.exports